import { faBars, faTimes } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import React from 'react'

import { Button } from '../Button'
import { Link } from '../Link'

import BlinkLogoDark from '../../img/blink-logo-dark.svg'
import BlinkLogoWhite from '../../img/blink-logo-white.svg'
import GtmClick from '../GtmClick'
import './styles.css'

type Props = {
  isLight?: boolean
}

type State = {
  isMenuOpen: boolean
  stickyMenu: boolean
}

const Navbar = class extends React.Component<Props, State> {
  state = {
    isMenuOpen: false,
    stickyMenu: false,
  }

  toggleMenu = () => {
    this.setState(state => ({
      isMenuOpen: !state.isMenuOpen,
    }))
  }

  closeMenu = () => {
    this.setState({
      isMenuOpen: false,
    })
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    const stickyMenu = window.scrollY > 100
    if (this.state.stickyMenu !== stickyMenu) {
      this.setState({
        stickyMenu,
      })
    }
  }

  render() {
    const isLight = this.props.isLight && !this.state.stickyMenu
    return (
      <div
        className={classNames('layout-body', {
          'navbar-sticky': this.state.stickyMenu,
        })}
      >
        <nav
          className={classNames('navbar', {
            'navbar-light': isLight,
          })}
          role="navigation"
          aria-label="main-navigation"
        >
          <div className="navbar-section">
            <Link to="/" className="navbar-item-logo" title="Logo">
              <GtmClick category="click" id={`gtm-nav-desktop-blink-logo`}>
                {isLight ? <BlinkLogoWhite /> : <BlinkLogoDark />}
              </GtmClick>
            </Link>
          </div>
          <div className="navbar-section">
            <div className="navbar-mobile-menu-button">
              <Button theme="text" onClick={this.toggleMenu}>
                <FontAwesomeIcon className="navbar-menu-button" icon={faBars} />
              </Button>
            </div>
            <div
              className={classNames('navbar-menu', {
                'navbar-menu-closed': !this.state.isMenuOpen,
              })}
            >
              <div className="navbar navbar-mobile-header layout-body">
                <div className="navbar-section">
                  <Link to="/" className="navbar-item-logo" title="Logo">
                    <GtmClick category="click" id={`gtm-nav-mobile-blink-logo`}>
                      <BlinkLogoDark />
                    </GtmClick>
                  </Link>
                </div>
                <div className="navbar-section">
                  <Button theme="text" onClick={this.closeMenu}>
                    <FontAwesomeIcon className="navbar-menu-close-button" icon={faTimes} />
                  </Button>
                </div>
              </div>
              <GtmClick category="click" id={`gtm-nav-calculators`}>
                <Link
                  className="navbar-item mr-1"
                  to="/calculator"
                  activeClassName="navbar-item-active"
                  onClick={this.closeMenu}
                >
                  Calculators
                </Link>
              </GtmClick>
              <GtmClick category="click" id={`gtm-nav-about-us`}>
                <Link
                  className="navbar-item mr-1"
                  to="/about-us"
                  activeClassName="navbar-item-active"
                  onClick={this.closeMenu}
                >
                  About us
                </Link>
              </GtmClick>
              <GtmClick category="click" id={`gtm-nav-faq`}>
                <Link
                  className="navbar-item mr-1"
                  to="/faq"
                  activeClassName="navbar-item-active"
                  onClick={this.closeMenu}
                >
                  FAQ
                </Link>
              </GtmClick>
              <GtmClick category="click" id={`gtm-nav-resources`}>
                <Link
                  className="navbar-item mr-1"
                  to="/resource-center"
                  activeClassName="navbar-item-active"
                  onClick={this.closeMenu}
                >
                  Resources
                </Link>
              </GtmClick>
              <div className="navbar-item-buttons">
                <GtmClick category="click" id={`gtm-nav-log-in`}>
                  <a
                    className="navbar-item navbar-item-login mr-1"
                    href={`${process.env.GATSBY_MTG_APP_URL}login`}
                  >
                    Log in
                  </a>
                </GtmClick>
                <GtmClick category="click" id={`gtm-nav-sign-up`}>
                  <Link className="navbar-item navbar-item-signup" to="/signup">
                    Sign up
                  </Link>
                </GtmClick>
              </div>
            </div>
          </div>
        </nav>
      </div>
    )
  }
}

export default Navbar
